import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import Third from "./Third_section/Third";
import Fourth from "./Fourth_section/Fourth";
import Fifth from "./Fifth_section/Fifth";
import Seventh from "./Seventh_section/Seventh";
import Sixth from "./Sixth_section/Sixth";
import Eight from "./Eight_section/Eight";
import Nineth from "./Nineth_section/Nineth";
import Last from "./Last_section/Last";

const D2C = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Fourth />
      <Fifth />
      <Sixth />
      <Seventh />
      <Eight />
      <Nineth />
      <Last />
      <Footer />
    </>
  );
};

export default D2C;
